/**
 * Shared date helpers for the pool period forms — lifted out of PeriodModal.tsx (were module-private
 * there) so PeriodModal's create branch AND BulkSetPeriodDialog default their range with the EXACT same
 * rule (today → +1 year) instead of each re-declaring it and inevitably drifting. Browser-local `today`
 * on purpose: this is the picker's default value an operator then edits, not a server-compared boundary
 * (the sweep's own BKK-clock comparison lives in hooks.ts's separate todayIso).
 */
import { addDays, addYears, format } from "date-fns";

export const todayIso = () => format(new Date(), "yyyy-MM-dd");

export const oneYearFrom = (iso: string) => {
  const d = new Date(`${iso}T00:00:00`);
  return Number.isNaN(d.getTime()) ? iso : format(addYears(d, 1), "yyyy-MM-dd");
};

/**
 * The DERIVED start of a planned next round: the day after the current round's last day (30/7,
 * คุณใหม่ "ห้ามเว้น — ต่อกันทันที"). Mirrors periods.next_period_start_for on the server and the
 * `next_period_contiguous` CHECK in pool_0009 — the operator never types this date, so the display
 * has to compute exactly what the server will store, or the form shows one date and saves another.
 */
export const dayAfter = (iso: string) => {
  const d = new Date(`${iso}T00:00:00`);
  return Number.isNaN(d.getTime()) ? iso : format(addDays(d, 1), "yyyy-MM-dd");
};
